import { createStackNavigator, StackHeaderProps } from '@react-navigation/stack'
import { ReplayNavigatorParams } from './types'
import i18n from '../i18n'
import {
  ReplayNavigationBar,
  ReplayNavigationBarProps,
} from '../screens/core/replay/replay.header'
import { ReplayProvider } from '../contexts/replay.context'
import ClusterCardsReplayScreen from '../screens/core/replay/cluster-card.replay.screen'
import PerspectiveReplayScreen from '../screens/core/replay/perspective.replay.screen'
import { ReplayContributionScreen } from '../screens/core/replay/contribution.replay.screen'
import ReplayPerspectiveContributionsScreen from '../screens/core/replay/perspective-contribution.replay.screen'
import ReplayClusterContributionsScreen from '../screens/core/replay/cluster-contribution.replay.screen'
import ReplayClusterListScreen from '../screens/core/replay/cluster-list.replay.screen'
const ReplayStack = createStackNavigator<ReplayNavigatorParams>()

export const ReplayNavigatorScreens = {
  ReplayClusterList: 'cluster-list',
  ReplayClusterCards: 'cluster-cards',
  ReplayPerspective: 'perspective',
  ReplayPerspectiveContributions: 'contributions',
  ReplayClusterContributions: 'cluster-contributions',
  Contribution: 'contribution',
}

export const ReplayNavigator = () => {
  return (
    <ReplayProvider>
      <ReplayStack.Navigator
        screenOptions={{
          header: (props: StackHeaderProps) => (
            <ReplayNavigationBar {...(props as ReplayNavigationBarProps)} />
          ),
        }}
      >
        <ReplayStack.Screen
          name="ReplayClusterList"
          component={ReplayClusterListScreen}
          options={{ title: i18n.t('screens:ClusterList') }}
        />
        <ReplayStack.Screen
          name="ReplayClusterCards"
          component={(props: any) => <ClusterCardsReplayScreen {...props} />}
          options={{ title: i18n.t('screens:ClusterCards') }}
        />
        <ReplayStack.Screen
          name="ReplayPerspective"
          component={(props: any) => <PerspectiveReplayScreen {...props} />}
          options={{ title: i18n.t('screens:Perspective') }}
        />
        <ReplayStack.Screen
          name="ReplayPerspectiveContributions"
          component={(props: any) => (
            <ReplayPerspectiveContributionsScreen {...props} />
          )}
          options={{ title: i18n.t('screens:PerspectiveContributions') }}
        />
        <ReplayStack.Screen
          name="ReplayClusterContributions"
          component={(props: any) => (
            <ReplayClusterContributionsScreen {...props} />
          )}
          options={{ title: i18n.t('screens:ClusterContributions') }}
        />
        <ReplayStack.Screen
          name="ReplayContribution"
          component={(props: any) => <ReplayContributionScreen {...props} />}
          options={{ title: i18n.t('screens:PerspectiveContribution') }}
        />
      </ReplayStack.Navigator>
    </ReplayProvider>
  )
}

export default ReplayNavigator
